<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="40%"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="form.password"
            placeholder="请输入密码"
            maxlength="20"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="分数" prop="star">
          <el-input
            v-model="form.star"
            placeholder="请输入分数"
            maxlength="3"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getStar, updateStar } from '@/api/mavin/base.js';

export default {
  name: 'Edit',
  data() {
    return {
      visible: false,
      loading: false,
      title: '',
      mavinEid: '',
      form: {}
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          updateStar(this.mavinEid, this.form)
            .then(res => {
              this.loading = false;
              this.msgSuccess();
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    show(mavinEid, title) {
      this.mavinEid = mavinEid;
      this.title = title;
      this.visible = true;

      this.loading = true;
      getStar(this.mavinEid).then(res => {
        this.loading = false;
        this.form = res;
      });
    }
  }
};
</script>

<style></style>
